import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsArrowRightNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.5 14.384l5.588-5.588c.44-.44.44-1.152 0-1.591L5.5 1.616l-.884.884 5.5 5.5-5.5 5.5z"
        fill=""
      />
    </svg>
  )
);
SvgActionsArrowRightNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsArrowRightNormalXsmall;
